/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCookingForACauseTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCookingForACause,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Cook for a Purpose!",
    "Cooking for a Cause Awaits!",
    "Delicious Food for a Great Cause!",
  ],
  title: "Cooking for a Cause",
  description: "Organize a fun cooking event for a cause.",
  longDescription:
    "Gather your friends for an exciting cooking event! Choose a date, decide on dishes to prepare for the cause, and plan activities!",
  emoji: "🍲",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cooking for a Cause",
          emoji: "🍲",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the cooking for a cause event?",
          emoji: "📅",
          completeAction: {
            question: "Decide on dishes to prepare?",
            description: "What dishes should we focus on during the event?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What dishes should we consider?",
                emoji: "🥘",
                completeAction: {
                  question: "Decide on ingredients needed?",
                  description: "What ingredients should we gather for cooking?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What ingredients should we bring?",
                      emoji: "🥕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Cook for a Good Cause!",
    outroDescription: "Your cooking for a cause plans are set! Enjoy the fun!",
  },
};
